var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlustraoWallbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4044 0.581003L13.9742 1.65202C10.7605 2.42892 7.9018 4.26477 5.85839 6.86396C2.79081 10.7659 1.89535 15.9506 3.47646 20.6554L14.3886 53.1257C17.2278 61.574 25.1449 67.2656 34.0576 67.2656H51.266C54.5803 67.2656 57.8343 66.3792 60.6908 64.6983C66.3652 61.3591 69.8491 55.2666 69.8491 48.6825V20.75C69.8491 9.29009 60.559 0 49.0991 0H23.2803C21.6377 0 20.001 0.195034 18.4044 0.581003Z",
    fill: "#00001C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.78027,
    width: 63.4375,
    height: 64.5312,
    rx: 15.5625,
    fill: "#36364A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.1615,
    y: 10.0874,
    width: 50.1632,
    height: 50.9834,
    rx: 25.0816,
    stroke: "#29E725",
    strokeWidth: 2.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.97 12.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5949 29.9375H23.6896C23.2568 29.9375 22.8418 30.1094 22.5358 30.4154L17.3723 35.5789L22.5358 40.7424C22.8418 41.0483 23.2568 41.2203 23.6896 41.2203H26.5949L20.9535 35.5789L26.5949 29.9375Z",
    fill: "#29E725"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8914 29.9375H40.7967C41.2294 29.9375 41.6444 30.1094 41.9504 30.4154L47.1139 35.5789L41.9504 40.7424C41.6444 41.0483 41.2294 41.2203 40.7967 41.2203H37.8914L43.5327 35.5789L37.8914 29.9375Z",
    fill: "#29E725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8776 29.9376V27.0323C37.8776 26.5996 37.7057 26.1846 37.3997 25.8786L32.2363 20.7151L27.0728 25.8786C26.7668 26.1846 26.5948 26.5996 26.5948 27.0323V29.9376L32.2363 24.2963L37.8776 29.9376Z",
    fill: "#29E725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5948 41.2202V44.1255C26.5948 44.5583 26.7668 44.9733 27.0728 45.2792L32.2363 50.4428L37.3997 45.2792C37.7057 44.9733 37.8776 44.5583 37.8776 44.1256V41.2202L32.2363 46.8616L26.5948 41.2202Z",
    fill: "#29E725"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9167 35.9112V38.7196L33.3832 36.2531C33.679 35.9573 33.8452 35.5561 33.8452 35.1379V32.3293L31.3787 34.7959C31.0829 35.0917 30.9167 35.4928 30.9167 35.9112Z",
    fill: "#29E725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraoWallbox);
export default __webpack_public_path__ + "static/media/Ilustração_wallbox.eb39d636d30101b919e452b1643f3635.svg";
export { ForwardRef as ReactComponent };